import { ApiResponse } from "@/types/api-response";
import { apiClient } from "@/api/api-client";
import { StoreSetting, BakongDetails, AbaDetails, SampleBakong, TransferResponse, SettingDeliveryFee } from "@/types/setting-type";



export async function getStoreSetting(
): Promise<ApiResponse<StoreSetting>> {
    const response = await apiClient.get<StoreSetting, {}>(`/stores/default`);
    return response;
}

export async function updateStoreSetting(data: StoreSetting) {
    const response = await apiClient.post<StoreSetting, StoreSetting>(`/stores/default`, data);
    return response;
}
export async function getSchedulerStatus() {
    const response = await apiClient.get<boolean, {}>(`/settings/poller`, {});
    return response;
}

export async function enableScheuler() {
    const response = await apiClient.post<{}, {}>(`/settings/poller/enable`, {});
    return response;
}

export async function disableScheuler() {
    const response = await apiClient.post<{}, {}>(`/settings/poller/disable`, {});
    return response;
}

export async function getWebhookEndpoint() {
    const response = await apiClient.get<string, {}>(`/settings/fb-endpoint`, {});
    return response;
}
export async function UpdateWebhookEndpoint(url: string) {
    const data = {
        key: 'endp',
        value: url,
        type: 'conf'
    };
    const response = await apiClient.post<string, {}>(`/settings/fb-endpoint`, data);
    return response;
}
export async function fetchCommentPoller() {
    const response = await apiClient.get<number, {}>(`settings/comment-poller`, {});
    return response;
}
export async function updateCommentPoller(duration: number) {
    const data = {
        key: 'endp',
        value: duration,
        type: 'conf'
    };
    const response = await apiClient.post<number, {}>(`settings/comment-poller`, data);
    return response;
}
export async function fetchAutoDetectComment() {
    const response = await apiClient.get<boolean, {}>(`settings/auto-detect-comment`, {});
    return response;
}
export async function updateAutoDetectComment(flag: boolean) {
    const data = {
        'value': flag
    };
    const response = await apiClient.post<boolean, {}>(`settings/auto-detect-comment`, data);
    return response;
}
export async function fetchAutoDetectChat() {
    const response = await apiClient.get<boolean, {}>(`settings/auto-detect-chat`, {});
    return response;
}

export async function updateAutoDetectChat(flag: boolean) {
    const data = {
        'value': flag
    };
    const response = await apiClient.post<boolean, {}>(`settings/auto-detect-chat`, data);
    return response;
}

export async function fetchKQRUrl() {
    const response = await apiClient.get<string, {}>(`settings/khqr`, {});
    return response;
}

export async function updateKHQRUrl(url: string) {
    const data = {
        'value': url
    };
    const response = await apiClient.post<string, {}>(`settings/khqr`, data);
    return response;
}
export async function fetCashOnDelivery() {
    const response = await apiClient.get<boolean, {}>(`settings/cod`, {});
    return response;
}

export async function updateCod(flag: boolean) {
    const data = {
        'value': flag
    };
    const response = await apiClient.post<boolean, {}>(`settings/cod`, data);
    return response;
}
export async function fetchEnableBakong() {
    const response = await apiClient.get<boolean, {}>(`settings/bakong`, {});
    return response;
}
export async function fetchEnableABA() {
    const response = await apiClient.get<boolean, {}>(`settings/aba`, {});
    return response;
}

export async function updateEnableBakong(flag: boolean) {
    const data = {
        'value': flag
    };
    const response = await apiClient.post<boolean, {}>(`settings/bakong`, data);
    return response;
}

export async function updateEnableABA(flag: boolean) {
    const data = {
        'value': flag
    };
    const response = await apiClient.post<boolean, {}>(`settings/aba`, data);
    return response;
}
export async function fetchBakongSetting() {
    const response = await apiClient.get<BakongDetails, {}>(`settings/bakong/account`, {});
    return response;
}

export async function updateBakongSetting(settingAccount: BakongDetails) {
    const response = await apiClient.post<BakongDetails, {}>(`settings/bakong/account`, settingAccount);
    return response;
}
export async function generateBakongSample() {
    const response = await apiClient.post<SampleBakong, {}>(`bakong/sample`);
    return response;
}

export async function checkBakongStatus(hash: string) {
    const response = await apiClient.post<TransferResponse, {}>(`bakong/check`, hash);
    return response;
}

export async function fetchAbaSetting() {
    const response = await apiClient.get<AbaDetails, {}>(`settings/aba/account`, {});
    return response;
}

export async function updateAbaSetting(settingAccount: AbaDetails) {
    const response = await apiClient.post<AbaDetails, {}>(`settings/aba/account`, settingAccount);
    return response;
}

export async function generateAbaSample() {
    const response = await apiClient.post<SampleBakong, {}>(`aba/sample`);
    return response;
}

export async function checkAbaStatus(hash: string) {
    const response = await apiClient.post<TransferResponse, {}>(`aba/check`, hash);
    return response;
}

export async function fetchDeliveryFee() {
    const response = await apiClient.get<SettingDeliveryFee, {}>(`settings/shipping`, {});
    return response;
}

export async function updateDeliveryFee(deliveryFee: SettingDeliveryFee) {
    const response = await apiClient.post<{}, {}>(`settings/shipping`, deliveryFee);
    return response;
}
export async function checkBakongSatus(tranId: string) {
    const response = await apiClient.get<TransferResponse, {}>(`usdt/bakong/${tranId}`);
    return response;
}
export async function binancePayout(address: string, amount: number, network: string) {
    const data = {
        address,
        amount,
        network
    };
    const response = await apiClient.post<string, {}>(`usdt/payout`, data);
    return response;
}
